import React, { useContext, useState } from 'react';
import { ProfileContext } from '../../../services/profile/profile.context';
import { ImageCropDialog } from '../../image-crop/image-crop-dialog';
import { SelectProfileImage } from './select-profile-image';

export const ProfileImageContainer = () => {
  const { profileImage, setProfileImage } = useContext(ProfileContext);
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        marginBottom: 32,
      }}
    >
      <SelectProfileImage
        setOpen={setOpen}
        image={profileImage}
        setImage={setProfileImage}
      />
      <ImageCropDialog
        open={open}
        id={1} // if update meeting or in profile
        profile={true}
        setOpen={setOpen}
        image={profileImage}
        setImage={setProfileImage}
      />
    </div>
  );
};
